import React, { useContext } from "react"
import SiteContext from "../../context/site-context"
import { getAchievements } from "../../lib/call-api";

export default function Achievements() {

  const { loadingSetState, achievementsState, achievementsSetState } = useContext(SiteContext)

  React.useEffect(() => {
    getAchievements().then(responce => {
      //console.log('Achievements responce', responce);
      if (responce === undefined){
        achievementsSetState([]);
      }
      else if (responce.status !== 200){
        achievementsSetState([]);
      }
      else {
        achievementsSetState(responce.data)

        loadingSetState(prevValues => (
           {...prevValues, achievementsLoaded: true}
        ))
      }
    })
  }, [])

  return (

    <div className="num-section" style={{ minHeight: "340px"}}>
      <div className="push70"/>

      <div className="container text-center">

        <div className="title-h1 bold white text-center">
          Наш успех в цифрах
        </div>

        <div className="row">
          {achievementsState.map(item => (
            <AchievementItem key={item.id} Title={item.title} IdNum={item.achievementType} DataNum={item.value} />
          ))}
        </div>
      </div>

      <div className="push60"/>
    </div>

  )
}

const AchievementItem = ({ Title, IdNum, DataNum }) => {
  const myRef = React.useRef(null)
  const offsetY = myRef.current?.getBoundingClientRect().y

  const [number, setNumber] = React.useState(() => {
    return DataNum
  })
  
  const [inView, setInView] = React.useState(() => {
    return false
  })


  function animateValue(start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      setNumber(Math.floor(progress * (end - start) + start));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  React.useEffect(() => {
    if (inView === false) {
      if (offsetY < 450) {
        setInView(true)
        animateValue(0, number, 2000)
      }
    }
  },[offsetY])

  const NumIdNum = "num " + IdNum

  return (
    <div ref={myRef} className="col-sm-3">
      <div className="element">
        <div className={"num " + NumIdNum + (inView ? " visible animated fadeInUp full-visible" : "")}>
          <span id={IdNum} data-num={DataNum}>{number}</span>
        </div>
        <p>{Title}</p>
      </div>
      <div className="push30 visible-xs"/>
    </div>
  )
}